import _ from 'lodash';
import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { FormattedHTMLMessage, FormattedMessage, injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Field, Form, getFormValues, isSubmitting, isValid, reduxForm } from 'redux-form';

import SdsButton from '../../../../commons/containers/SdsButton';
import SdsLoginButton from '../../../../commons/containers/SdsLoginButton';
import SdsError from '../../../../commons/containers/SdsError';
import SdsInput from '../../../../commons/containers/SdsInput';
import Divider from '../../../../commons/containers/Divider';
import { ROUTES } from '../../../../commons/routes/routes';
import {
  formatCnpj,
  formatCpfOuCnpj,
  obrigatorio,
  validateCnpjLogin,
  validateCpfOuCnpj
} from '../../../../commons/validation/validation';
import AppLoading from '../../../AppLayout/containers/AppLoading';
import { LinkRouterStyled } from '../../../../commons/containers/LinkStyled';
import {
  consts as configConst,
  selectors as configuracacoesSelector
} from '../../../../redux/modules/configuracoes';

import './LoginForm.css';
import { getMtLoginUrl } from '../oauth2/mtLogin';

class LoginForm extends PureComponent {
  constructor(props) {
    super(props);
    this.recaptchaRef = React.createRef();
  }

  resetReCaptcha = () => {
    if (!this.props.captchaEnabled) return;
    this.recaptchaRef.current.reset();
  };

  validateReCaptcha = () => {
    if (!this.props.captchaEnabled) return;
    this.recaptchaRef.current.execute();
  };

  getReCaptcha = () => {
    if (!this.props.captchaEnabled) return;
    return this.recaptchaRef.current.getValue();
  };

  login = () => {
    const form = this.props.formLoginValues;
    const payload = {
      usuario: form.identificacao,
      senha: form.senha,
      redirectUrl: this.props.redirectUrl,
      redirecPageDefault: this.props.redirecPageDefault,
      captcha: this.getReCaptcha()
    };
    this.props.login(payload);
    this.resetReCaptcha();
  };

  handleOpenIdLogin = async () => {
	  const url = await getMtLoginUrl();
    if (url) {
      window.location.href = url; // redireciona para o MT-Login
    } else {
      console.error('URL do MT-Login não configurada');
    }
  };

  render() {
    const {
      erro,
      loading,
      valid,
      submitting,
      handleSubmit,
      captchaEnabled,
      captchaSitekey,
      config
    } = this.props;

    const fnHandleSubmit = this.login;
    const fnSubmit = captchaEnabled ? this.login : this.validateReCaptcha;
    const identificacao = _.get(this.props, 'formLoginValues.identificacao');
    const usarObrasGov = config.EXIBE_BOTAO_GOV_BR_LOGIN;
    const validateUserName = [obrigatorio, usarObrasGov ? validateCnpjLogin : validateCpfOuCnpj];
    const labelUserName = usarObrasGov ? 'LABELS.COMMONS.USUARIO.CNPJ' : 'LABELS.COMMONS.USUARIO.IDENTIFICACAO';
    const formatUserName = usarObrasGov ? formatCnpj : formatCpfOuCnpj;

    const isOpenIdActive = config.EXIBE_BOTAO_OPENID_LOGIN;
    const exibeLoginUsuarioSenha = config.EXIBE_LOGIN_USUARIO_SENHA !== false

    return (
      <section className="sds-container" style={{ display: 'flex', alignItems: 'center', minHeight: '100%' }}>
        <div className="sds-row sds-center-xs" style={{ width: '100%' }}>
          <div className="sds-col-xs-12 sds-col-md-8 sds-col-lg-6">
            <div className="sds-card-container" style={!exibeLoginUsuarioSenha ? { display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', textAlign: 'center' } : undefined}>
              <AppLoading show={loading} msg="LABELS.COMMONS.LOGIN.LOADING" />

              <div className="sds-form-group">
                <h5>
                  <strong>
                    <FormattedHTMLMessage id="LABELS.COMMONS.PORTAL.PORTAL_DE_SERVICOS" />
                  </strong>
                </h5>
              </div>

              <div className="sds-form-group">
                <h6>
                  <FormattedHTMLMessage id="LABELS.COMMONS.LOGIN.TITULO" />
                </h6>
              </div>

              <div className="sds-form-group">
                <FormattedHTMLMessage id="textoPfGovBr" defaultMessage="Pessoa Física" />
              </div>

              {usarObrasGov && (
                <>
                  <div className="sds-form-group">
                    <SdsButton
                      fullwidth
                      br20
                      govBr
                      onClick={() =>
                        window.open(
                          `${window.location.origin}/portal-servicos-oauth/oauth2/authorize/govbr?redirect_uri=${window.location.origin}/portal-servicos-frontend/oauth2/redirect`,
                          '_self'
                        )
                      }
                      label="Entrar com gov.br"
                    />


                  </div>


                  <div className="sds-form-group">
                    <div className="separator">
                      <Divider>
                        <span className="span-ou">ou</span>
                      </Divider>
                    </div>
                  </div>
                </>
              )}

              {isOpenIdActive && (
                    <div className="sds-form-group">
                      <SdsLoginButton
                        fullwidth
                        br20
                        govBr
                        onClick={() =>
                          window.open(
                            `${window.location.origin}/portal-servicos-oauth/oauth2/authorize/mtlogin`,
                            '_self'
                          )
                        }
                        //label="Entrar com mt-login"
                        >
                        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                          Entrar com <img className="sds-page-centered" width="90px" height="15px"
                          src={`${process.env.REACT_APP_PORTAL_SERVICOS_BACKEND}/configuracoes/frontend/download/logo.mtlogin`}
                          alt="logo do mtlogin" />
                        </div>
                      </SdsLoginButton>

                    </div>
                  )}

              {exibeLoginUsuarioSenha && (
                <div className="sds-form-group">
                  <p className="sds-p">
                    <FormattedHTMLMessage id="textoLoginPortal" defaultMessage="Pessoa Jurídica, faça seu login" />
                  </p>
                </div>
              )}

              {exibeLoginUsuarioSenha && (
                <Form onSubmit={handleSubmit(fnHandleSubmit)}>
                  {captchaEnabled && (
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      size="invisible"
                      sitekey={captchaSitekey}
                      onChange={fnSubmit}
                    />
                  )}

                  <SdsError msg={erro} />

                  <Field
                    autoFocus
                    autoComplete="username"
                    name="identificacao"
                    label={labelUserName}
                    type="text"
                    component={SdsInput}
                    validate={validateUserName}
                    normalize={formatUserName}
                  />

                  <Field
                    autoComplete="password"
                    name="senha"
                    type="password"
                    component={SdsInput}
                    label="LABELS.COMMONS.USUARIO.SENHA"
                    validate={[obrigatorio]}
                  />

                  <div className="sds-form-group">
                    <SdsButton
                      raised
                      fullwidth
                      type="submit"
                      label="LABELS.COMMONS.LOGIN.ENTRAR"
                      disabled={!valid || submitting}
                    />
                  </div>
                </Form>
              )}

              {exibeLoginUsuarioSenha && (
                <div className="sds-row sds-center-xs">
                  <div className="sds-col-xs-12">
                    <LinkRouterStyled
                      to={{
                        pathname: ROUTES.RECUPERAR_SENHA.path,
                        state: { identificacao: identificacao }
                      }}
                      className="sds-link"
                    >
                      <FormattedMessage id="LABELS.COMMONS.LOGIN.ESQUECEU_A_SENHA" />
                    </LinkRouterStyled>
                  </div>
                </div>
              )}
            </div>
          </div>

          {exibeLoginUsuarioSenha && (
            <div className="sds-col-xs-12 sds-margin-vertical" style={{ textAlign: 'center' }}>
              <p className="sds-p">
                <FormattedMessage
                  id="LABELS.COMMONS.LOGIN.NAO_POSSUI_CONTA"
                  values={{
                    'route-to-criar-conta': (
                      <LinkRouterStyled to={ROUTES.CRIAR_CONTA.path} className="sds-link">
                        <FormattedMessage id="LABELS.COMMONS.LOGIN.CRIAR_CONTA" />
                      </LinkRouterStyled>
                    )
                  }}
                />
              </p>
            </div>
          )}
        </div>
      </section>
    );
  }
}

LoginForm.defaultProps = {
  erro: undefined,
  redirectUrl: undefined
};

LoginForm.propTypes = {
  login: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  captchaEnabled: PropTypes.bool.isRequired,
  captchaSitekey: PropTypes.string,
  redirectUrl: PropTypes.string,
  erro: PropTypes.string
};

const FORM_ID = 'form_login';

function mapStateToProps(state) {
  return {
    formLoginValues: getFormValues(FORM_ID)(state),
    valid: isValid(FORM_ID)(state),
    submitting: isSubmitting(FORM_ID)(state),
    config: configuracacoesSelector.getValorConfiguracao(
      state,
      configConst.APPLICATION_CONFIG_RESOURCES
    )
  };
}

export default compose(
  connect(mapStateToProps),
  reduxForm({ form: FORM_ID, touchOnChange: true, touchOnBlur: false }),
  injectIntl
)(LoginForm);
